<template>
  <div class="columns">
    <div class="column">
      <window title="Float label <a href='https://github.com/bkzl/vue-float-label' target='_blank'>(more info)">
        <float-label>
          <input class="input" type="text" placeholder="Label">
        </float-label>
      </window>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueFloatLabel from 'vue-float-label';

Vue.use(VueFloatLabel);

export default {
};
</script>
